import { isTouch } from '../core/device';
import type { MeterView } from '../systems/Stunts';
import { h } from './dom';
import { setRich } from '../icons/dom';

/** The "hold my beer" timing meter shown during trampoline stunts. */
export class StuntMeter implements MeterView {
  private readonly el: HTMLDivElement;
  private readonly title: HTMLDivElement;
  private readonly zone: HTMLDivElement;
  private readonly needle: HTMLDivElement;
  private readonly pips: HTMLDivElement;
  private hint!: HTMLDivElement;
  private presses = 1;

  /** `onTap` fires when the meter itself is tapped (touch devices only). */
  constructor(parent: HTMLElement, onTap: () => void) {
    this.title = h('div', { class: 'meter-title' });
    this.zone = h('div', { class: 'meter-zone' });
    this.needle = h('div', { class: 'meter-needle' });
    this.pips = h('div', { class: 'meter-pips' });
    this.el = h(
      'div',
      { class: 'meter cardboard', hidden: true },
      this.title,
      h('div', { class: 'meter-track' }, this.zone, this.needle),
      this.pips,
      (this.hint = h('div', { class: 'meter-hint' })),
    );
    this.el.addEventListener('pointerdown', (e) => {
      if (!isTouch()) return;
      e.preventDefault();
      onTap();
    });
    parent.append(this.el);
  }

  show(name: string, presses: number): void {
    this.presses = presses;
    setRich(this.title, `:cartwheel: ${name}`);
    this.hint.textContent = isTouch()
      ? 'TAP HERE when the needle is in the GREEN!'
      : 'Press SPACE when the needle is in the GREEN!';
    this.el.classList.toggle('interactive', isTouch());
    this.el.hidden = false;
  }

  hide(): void {
    this.el.hidden = true;
  }

  render(
    needle: number,
    zoneCenter: number,
    zoneWidth: number,
    done: number,
    flash: 'hit' | 'miss' | null,
  ): void {
    this.zone.style.left = `${(zoneCenter - zoneWidth / 2) * 100}%`;
    this.zone.style.width = `${zoneWidth * 100}%`;
    this.needle.style.left = `${needle * 100}%`;
    setRich(this.pips, ':pip-on:'.repeat(done) + ':pip-off:'.repeat(Math.max(0, this.presses - done)));
    this.el.classList.toggle('hit', flash === 'hit');
    this.el.classList.toggle('miss', flash === 'miss');
  }
}
